module.exports = __webpack_public_path__ + "img/employee.1dc4ba07.svg";